module.exports = __webpack_public_path__ + "img/drivers-outdoor.2365ec56.jpg";